import { SettingLimitResponse, StudentsResponse } from "./dtos/account.dto";
import { SettingUpdateLimit } from "@components/resolvers/setting.resolver";
import { BaseResponse } from "./dtos/base.dto";
import { BaseService } from "./base.service";

interface AccountServiceInterface {
  queries: {
    GET_SETTING_LIMIT: string;
    GET_ACCOUNT_STUDENTS: string;
  };
  settingLimit(nis: string): Promise<SettingLimitResponse>;
  updateSettingLimit(
    payload: SettingUpdateLimit,
  ): Promise<BaseResponse<boolean>>;
  students(): Promise<StudentsResponse>;
  changeStudent(nis: string): Promise<BaseResponse<boolean>>;
  updateTokenFirebase(token: string): Promise<BaseResponse<boolean>>;
}

export const AccountService: AccountServiceInterface = {
  queries: {
    GET_SETTING_LIMIT: "GET_SETTING_LIMIT",
    GET_ACCOUNT_STUDENTS: "GET_ACCOUNT_STUDENTS",
  },

  settingLimit: async (nis: string) => {
    try {
      const request = await BaseService.ci4Request().get(
        `/keuangan/limit/${nis}`,
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.message,
        data: false,
      };
    }
  },

  updateSettingLimit: async (payload) => {
    try {
      const request = await BaseService.ci4Request().post(
        "/keuangan/update-limit",
        payload,
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.message,
        data: false,
      };
    }
  },

  students: async () => {
    try {
      const request =
        await BaseService.request().get<StudentsResponse>("/account/students");
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  changeStudent: async (nis: string) => {
    try {
      const request = await BaseService.request().get<BaseResponse<boolean>>(
        `/account/change-student/${nis}`,
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  updateTokenFirebase: async (token: string) => {
    try {
      const request = await BaseService.request().post<BaseResponse<boolean>>(
        "/account/update-token-firebase",
        { token },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
